import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Brain, X, Send, MessageSquare, Sparkles } from 'lucide-react';
export function AIAssistant() {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([{
    id: 1,
    text: "Hi! I'm Renta AI. How can I help you today?",
    sender: 'bot'
  }]);
  const [input, setInput] = useState('');
  const handleSend = () => {
    if (!input.trim()) return;
    setMessages([...messages, {
      id: Date.now(),
      text: input,
      sender: 'user'
    }]);
    setInput('');
    // Simulate AI response
    setTimeout(() => {
      setMessages(prev => [...prev, {
        id: Date.now() + 1,
        text: 'I can help with that! Based on your transaction history, I recommend checking your cashflow predictor to optimize your next payment.',
        sender: 'bot'
      }]);
    }, 1000);
  };
  return <>
      <motion.button whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} onClick={() => setIsOpen(true)} className="fixed bottom-6 right-6 w-14 h-14 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full shadow-lg flex items-center justify-center text-white z-50 hover:shadow-xl transition-shadow" data-id="element-264">
        <Brain className="w-7 h-7" data-id="element-265" />
        <span className="absolute top-0 right-0 w-3 h-3 bg-green-400 rounded-full border-2 border-white" data-id="element-266"></span>
      </motion.button>

      <AnimatePresence data-id="element-267">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} className="fixed bottom-24 right-6 w-80 sm:w-96 bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden z-50 flex flex-col max-h-[600px]" data-id="element-268">
            {/* Header */}
            <div className="p-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white flex justify-between items-center" data-id="element-269">
              <div className="flex items-center" data-id="element-270">
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mr-3 backdrop-blur-sm" data-id="element-271">
                  <Brain className="w-5 h-5" data-id="element-272" />
                </div>
                <div data-id="element-273">
                  <h3 className="font-bold text-sm" data-id="element-274">Renta AI Assistant</h3>
                  <p className="text-xs text-blue-100 flex items-center" data-id="element-275">
                    <span className="w-1.5 h-1.5 bg-green-400 rounded-full mr-1.5" data-id="element-276"></span>
                    Online
                  </p>
                </div>
              </div>
              <button onClick={() => setIsOpen(false)} className="p-1 hover:bg-white/10 rounded-lg transition-colors" data-id="element-277">
                <X className="w-5 h-5" data-id="element-278" />
              </button>
            </div>

            {/* Messages */}
            <div className="flex-1 p-4 overflow-y-auto bg-gray-50 h-80 space-y-4" data-id="element-279">
              {messages.map(msg => <div key={msg.id} className={`flex ${msg.sender === 'user' ? 'justify-end' : 'justify-start'}`} data-id="element-280">
                  <div className={`max-w-[80%] p-3 rounded-2xl text-sm ${msg.sender === 'user' ? 'bg-blue-600 text-white rounded-br-none' : 'bg-white text-gray-800 border border-gray-200 rounded-bl-none shadow-sm'}`} data-id="element-281">
                    {msg.text}
                  </div>
                </div>)}
            </div>

            {/* Suggestions */}
            <div className="p-2 bg-gray-50 border-t border-gray-100 overflow-x-auto whitespace-nowrap" data-id="element-282">
              <div className="flex space-x-2 px-2" data-id="element-283">
                <button className="px-3 py-1.5 bg-white border border-purple-200 text-purple-700 rounded-full text-xs font-medium hover:bg-purple-50 flex items-center shadow-sm" data-id="element-284">
                  <Sparkles className="w-3 h-3 mr-1" data-id="element-285" /> Check Risk Score
                </button>
                <button className="px-3 py-1.5 bg-white border border-blue-200 text-blue-700 rounded-full text-xs font-medium hover:bg-blue-50 flex items-center shadow-sm" data-id="element-286">
                  <TrendingUp className="w-3 h-3 mr-1" data-id="element-287" /> Predict Cashflow
                </button>
              </div>
            </div>

            {/* Input */}
            <div className="p-4 bg-white border-t border-gray-200" data-id="element-288">
              <div className="flex items-center bg-gray-100 rounded-full px-4 py-2" data-id="element-289">
                <input type="text" value={input} onChange={e => setInput(e.target.value)} onKeyPress={e => e.key === 'Enter' && handleSend()} placeholder="Ask me anything..." className="flex-1 bg-transparent border-none focus:ring-0 text-sm placeholder-gray-500" data-id="element-290" />
                <button onClick={handleSend} className="p-1.5 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-colors" data-id="element-291">
                  <Send className="w-4 h-4" data-id="element-292" />
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}